import React, { useState } from "react";

interface FAQItem {
  question: string;
  answer: string;
}

const Faq: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

 const faqItems: FAQItem[] = [
    {
      question: "Ile kosztuje oczyszczenie zarośniętej działki?",
      answer:
        "Koszt oczyszczenia zarośniętej działki zależy od stopnia zagęszczenia krzaków, samosiejek oraz wielkości terenu. Cena ustalana jest indywidualnie po bezpłatnych oględzinach, biorąc pod uwagę konieczność użycia ciężkiego sprzętu lub ręcznego usuwania korzeni. Kompleksowa usługa pozwala przygotować teren pod sprzedaż lub inwestycję w sposób najbardziej ekonomiczny.",
    },
    {
      question: "Ile kosztuje mulczowanie działki?",
      answer:
        "Cena za mulczowanie działki zależy przede wszystkim od powierzchni (liczby hektarów lub metrów kwadratowych) oraz rodzaju roślinności do usunięcia. Mulczowanie to jedna z najtańszych i najszybszych metod oczyszczania terenu, ponieważ eliminuje koszty wywozu i utylizacji odpadów zielonych, zamieniając zarośla w żyzną biomasę.",
    },
    {
      question: "Co wybrać: mulczowanie czy karczowanie?",
      answer:
        "Wybór zależy od planowanego przeznaczenia terenu. Mulczowanie jest idealne do szybkiego porządkowania działek i usuwania nadziemnych części krzaków. Jeśli jednak planujesz fundamenty, drogę dojazdową lub trawnik, lepszym rozwiązaniem będzie karczowanie, które pozwala na całkowite usunięcie korzeni i pni z gruntu.",
    },
    {
      question: "Jak przygotować działkę pod budowę?",
      answer:
        "Przygotowanie działki pod budowę domu obejmuje kilka kluczowych etapów: usunięcie zbędnych drzew i krzewów, karczowanie korzeni, a następnie profesjonalną niwelację terenu. Ważne jest również zdjęcie warstwy humusu w miejscu planowanych fundamentów oraz utwardzenie drogi dojazdowej dla ciężkiego sprzętu budowlanego.",
    },
    {
      question: "Jak oczyścić działkę z krzaków i drzew?",
      answer:
        "Najskuteczniejszym sposobem na oczyszczenie działki z krzaków i drzew jest połączenie wycinki klasycznej z użyciem mulczera leśnego lub frezarki do pni. Nasza ekipa dobiera metodę do gęstości zarośli, zapewniając szybkie i bezpieczne usunięcie roślinności wraz z uporządkowaniem pozostałości, co przywraca działce jej pełną wartość użytkową.",
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col lg:flex-row items-start justify-start lg:items-center lg:justify-between gap-6 lg:gap-12">
        <div className="w-full flex flex-col gap-4">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className={`rounded-xl p-6 flex flex-col bg-gray-50 border border-gray-100 text-left gap-2 cursor-pointer hover:bg-gray-200 transition-all duration-200`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="flex flex-row items-center justify-between">
                <p className="font-semibold color-green text-lg lg:text-2xl">
                  {item.question}
                </p>
                <div className="shrink-0 rounded-full bg-green text-white text-center w-10 h-10 text-xl font-semibold flex flex-col items-center justify-center">
                  <p>{openIndex === index ? "-" : "+"}</p>
                </div>
              </div>
              <p
                className={`text-gray-600 transition-all duration-300 ${
                  openIndex === index ? "block" : "hidden"
                }`}
              >
                {item.answer}
              </p>
            </div>
          ))}
        </div>

        <div className="flex flex-col items-start justify-start gap-2 w-full lg:w-2/3">
          <h2 className="uppercase color-yellow text-xl">Faq</h2>
          <h3 className="text-3xl lg:text-5xl color-green text-left">
            Najczęściej <br className="hidden lg:block" />
            zadawane <span className="color-yellow">pytania</span>
          </h3>
          <div className="flex flex-col items-start justify-start gap-1 bg-yellow p-6 rounded-xl w-full mt-2">
            <p className="text-2xl font-semibold text-white font-head">
              Wciąż masz pytania?
            </p>
            <p className="text-white text-xl">Porozmawiajmy!</p>
            <a href="/kontakt" className="w-full mt-2">
              <button className="button-green w-full">
                Skontaktuj się z nami
              </button>
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq;
